// export const generateCourierPayload = (order) => {
//   if (!order) {
//     console.error("❌ No order provided.");
//     return null;
//   }

//   if (!order.shipcluesOrderId) {
//     console.error("❌ Missing shipcluesOrderId in order:", order);
//     return null;
//   }

//   const {
//     Weight,
//     Height,
//     Length,
//     Breadth,
//     PaymentType,
//     PickupAddress,
//     ShippingAddress,
//     InvoiceAmount,
//     OrderType,
//   } = order;

//   if (
//     !Weight ||
//     !Height ||
//     !Length ||
//     !Breadth ||
//     !PickupAddress?.Pincode ||
//     !ShippingAddress?.Pincode
//   ) {
//     console.error("❌ Missing required fields in order:", {
//       Weight,
//       Height,
//       Length,
//       Breadth,
//       PickupAddress,
//       ShippingAddress,
//     });
//     return null;
//   }

//   return {
//     weight: Weight,
//     height: Height,
//     length: Length,
//     breadth: Breadth,
//     rate_type: OrderType || "forward",
//     is_reverse_qc: "n",
//     total_amount: InvoiceAmount?.toString() || "1",
//     fromPincode: PickupAddress?.Pincode,
//     toPincode: ShippingAddress?.Pincode,
//     payment_method: PaymentType === "prepaid" ? "prepaid" : "cod",
//   };
// };

// utils/helpers.js
export const generateCourierPayload = (order) => {
  if (!order?.BillingAddress || !order?.ShippingAddress) {
    console.error("🚨 Missing address details in order:", order);
    return null;
  }
  const billing = order.BillingAddress || order.billingAddress || {};
  const shipping = order.ShippingAddress || order.shippingAddress || {};

  const payload = {
    pickup_postcode: shipping?.Pincode || shipping?.Pincode ,
    delivery_postcode: billing?.Pincode || billing?.Pincode ,
    weight: Number(order.Weight),
    cod: (order.PaymentType || "").toLowerCase() === "cod" ? 1 : 0,
    declared_value: Number(order.InvoiceAmount) ,
    length: Number(order.Length) ,
    breadth: Number(order.Breadth) ,
    height: Number(order.Height) ,
    is_return: 0,
  };
  console.log("🚀 Generated payload:", payload);
  return payload;
};
